import { Flex, Td, Tr as ChakraTr, Text, Tooltip } from '@chakra-ui/react'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../../utils/capitalFirstLetter'
import { UsageButton } from './UsageButton'
import { ConfirmDialog } from './ConfirmDialog'
import { ModalJ3 } from './ModalJ3'
import { useMergePdf } from '../../../../hooks/useMergePdf'

export function Tr({ data, idx, resultado, rowClicked, handleRowClick }) {
  const { mergePdf, loading } = useMergePdf()

  const openTabs = async (data) => {
    data.forEach((link) => {
      window.open(link, '_blank')
    })
  }

  return (
    <ChakraTr
      id="id_tr"
      key={data?.numero_unico}
      bgColor={rowClicked === data?.numero_unico && '#2fa456'}
      color={rowClicked === data?.numero_unico && '#fff'}
    >
      <Td paddingInline=".3rem" textAlign="center">
        <Text as="a" href={data.link_layout} target="_blank" color="blue.500" textDecoration="underline">
          {data?.numero_pedido}
        </Text>
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        {data?.numero_nota_show}
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        {data?.data_pronto}
      </Td>

      <Td paddingInline=".3rem" textAlign="center">
        {data?.tipo_envio}
        {data?.isJ3 && <ModalJ3 refresh={resultado} nunota={data?.numero_nota} qtdCaixas={data?.quantidades_caixa} />}
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        {data?.limite_producao}
      </Td>

      <Td paddingInline=".3rem" textAlign="center">
        {data?.nome_parc.length > 11
          ? firstLetterUpperCaseAndRestLowerCase(data?.nome_parc.substring(0, 11)) + '...'
          : firstLetterUpperCaseAndRestLowerCase(data?.nome_parc)}
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        <Tooltip label={data?.nome_vendedor} aria-label="A tooltip">
          {firstLetterUpperCaseAndRestLowerCase(data?.nome_vendedor)}
        </Tooltip>
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        {data?.peso_total} Kg
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        {data?.quantidades_caixa}
      </Td>
      <Td paddingInline=".3rem" textAlign="center">
        R$ {data?.valor_nota}
      </Td>
      <Td paddingInline=".3rem" textAlign="center" width="200px">
        <Flex align="center" width="100%" justifyContent="space-between">
          {data?.etiqueta_melhorenvio && <UsageButton link={data.etiqueta_melhorenvio} text="Melhor Envio" idx={idx} onClick={handleRowClick} />}
          {data?.valida_tracken && (
            <UsageButton
              link={`${process.env.REACT_APP_BASE_URL}/site/v2/tracken/verifica-etiqueta-tracken/${data?.numero_pedido}`}
              text="Tracken"
              idx={idx}
              onClick={handleRowClick}
            />
          )}
          {data?.codigo_kangu !== '0' && (
            <UsageButton
              link={`${process.env.REACT_APP_BASE_URL}/site/v2/frete-transp-kangu/visualiza-etiqueta-kangu/${data?.codigo_kangu}`}
              text="Etqt. Kangu"
              idx={idx}
              isKangu
              onClick={handleRowClick}
            />
          )}

          {data?.valida_etiqueta === 'S' && (
            <UsageButton
              link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiqueta-nfe/${data?.numero_nota}`}
              text="Etqt. Endereço"
              idx={idx}
              onClick={handleRowClick}
            />
          )}
          {/* https://api.innovationbrindes.com.br/api/site/v2/orcamento/visualiza-nota-fisc-fisc/192519 */}
          <UsageButton
            link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiquetas/${data?.numero_nota}`}
            text="Etiqueta"
            idx={idx}
            onClick={handleRowClick}
          />
          <UsageButton
            link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${data?.numero_nota}`}
            text="Nota"
            idx={idx}
            onClick={handleRowClick}
          />

          {data?.boletos?.length > 0 && (
            <UsageButton
              // link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${data?.numero_nota}`}
              text={`${data?.boletos?.length > 1 ? 'Boletos' : 'Boleto'}` + ` (${data?.boletos?.length})`}
              idx={idx}
              onClick={() => openTabs(data?.boletos)}
            />
          )}

          {/* <Boletos boletos={data?.boletos} idx={idx} /> */}

          <UsageButton
            link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-xml/${data?.numero_nota}`}
            text="XML"
            idx={idx}
            onClick={handleRowClick}
          />
          {data?.remessa === '' ? (
            <></>
          ) : (
            <>
              <UsageButton
                link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${data?.nota_remessa}`}
                text="Remessa"
                idx={idx}
                onClick={handleRowClick}
              />
              <UsageButton
                link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-xml/${data?.nota_remessa}`}
                text="XML Remessa"
                idx={idx}
                onClick={handleRowClick}
              />
            </>
          )}
        </Flex>
      </Td>
      <Td textAlign="center">
        <ConfirmDialog item={data} resultado={resultado} />
      </Td>
    </ChakraTr>
  )
}
